// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavLinks_menu__3qgFt","active":"NavLinks_active__3GVyz"};